<template>
  <v-container fluid class="px-6">
    <div class="flex-col-start-start gap-4">
      <div class="flex-row-between-center w-100">
        <HistoryFilter
          :filterData="filter"
          :loading="filterLoading"
          @filter="handleFilter"
        />
        <HistoryExport
          title="Prediction"
          :filterData="filter"
          :exportData="exportData"
          :disabled="predictionHistory.length === 0"
        />
      </div>
      <Loader v-if="loading" />
      <NoRecord v-else-if="predictionHistory.length === 0" />
      <div class="flex-col-start-start gap-2 w-100" v-else>
        <PredictionHistoryCard
          v-for="predictionData in predictionHistory"
          :key="predictionData.id"
          :predictionData="predictionData"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { GET_PREDICTIONS_HISTORY } from "@/core/services/store/modules/hmi/hmi.module";
import { mapGetters } from "vuex";
import PredictionHistoryCard from "./fragments/history.card.vue";
import NoRecord from "@/components/lists/NoRecord.vue";
import Loader from "@/components/lists/Loader.vue";
import HistoryFilter from "@/components/lists/HistoryFilter.vue";
import HistoryExport from "@/components/lists/HistoryExport.vue";
import moment from "jalali-moment";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "PredictionHistory",

  data() {
    return {
      loading: false,
      filterLoading: false,
      filter: {
        created_at_from: undefined,
        created_at_to: undefined,
        limit: undefined,
      },
    };
  },

  computed: {
    ...mapGetters(["predictionHistory"]),
    exportData() {
      const data = [];
      const headers = [
        "time",
        "interval",
        "carbon",
        "metallization",
        "production rate",
      ];

      this.predictionHistory.forEach((prediction) => {
        const time = moment(new Date(prediction.time)).format(
          "jYYYY/jMM/jDD hh:mm"
        );
        Object.keys(prediction.inputParameters).forEach((key) => {
          if (!headers.includes(key)) headers.push(key);
        });

        data.push({
          time,
          interval: prediction.interval,
          carbon: prediction.carbon,
          metallization: prediction.metallization,
          "production rate": prediction.productionRate,
          ...prediction.inputParameters,
        });
      });

      return { headers, data };
    },
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.filterLoading = true;
      await this.$store
        .dispatch(GET_PREDICTIONS_HISTORY, this.filter)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.filterLoading = false;
        });
    },
    handleFilter({ key, value }) {
      this.filter = { ...this.filter, [key]: value };
    },
  },

  watch: {
    filter: async function (value) {
      this.filterLoading = true;
      await this.$store
        .dispatch(GET_PREDICTIONS_HISTORY, value)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.filterLoading = false;
        });
    },
  },

  components: {
    PredictionHistoryCard,
    HistoryExport,
    NoRecord,
    Loader,
    HistoryFilter,
  },
};
</script>
